import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface CalendarFiltersState {
  filtersVisible: boolean;
  /** Desktop work-order calendar navigation row; hidden from the tab row (#4182). */
  toolbarVisible: boolean;
  /** Month calendar beside the day view; opt-in so the timeline keeps its width (#4182). */
  miniCalendarVisible: boolean;
  setFiltersVisible: (visible: boolean) => void;
  toggleFiltersVisible: () => void;
  toggleToolbarVisible: () => void;
  toggleMiniCalendarVisible: () => void;
}

export const useCalendarFiltersStore = create<CalendarFiltersState>()(
  persist(
    (set) => ({
      filtersVisible: false,
      toolbarVisible: true,
      miniCalendarVisible: false,
      setFiltersVisible: (visible) => set({ filtersVisible: visible }),
      toggleFiltersVisible: () =>
        set((state) => ({ filtersVisible: !state.filtersVisible })),
      toggleToolbarVisible: () =>
        set((state) => ({ toolbarVisible: !state.toolbarVisible })),
      toggleMiniCalendarVisible: () =>
        set((state) => ({ miniCalendarVisible: !state.miniCalendarVisible })),
    }),
    {
      name: 'staff-portal-calendar-filters',
      partialize: (state) => ({
        filtersVisible: state.filtersVisible,
        toolbarVisible: state.toolbarVisible,
        miniCalendarVisible: state.miniCalendarVisible,
      }),
    }
  )
);
